module.exports = __webpack_public_path__ + "static/media/ww_pad1.15e05140.gif";